import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PendingSubscriptionPage } from '../../../../components/pages/backoffice/common/pending-subscription-page.tsx'
import { QuoteChangesSimulatorProvider } from '../../../../components/pages/backoffice/common/quote-changes-simulator-provider.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/$subscriptionId/')({
  component: function BackofficeSubscriptionRoute() {
    const { subscriptionId } = Route.useParams()
    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('subscription.read', 'subscription.read.relatedOnly')]}>
        <QuoteChangesSimulatorProvider subscriptionId={subscriptionId}>
          <PendingSubscriptionPage />
        </QuoteChangesSimulatorProvider>
      </PermissionChecker>
    )
  },
})
